import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/ferias/:year',
    name: 'Holidays',
    component: () => import('../views/HolidaysView.vue')
  },
  {
    path: '/prazos',
    name: 'Timeline',
    component: () => import('../views/TimelineView.vue')
  },
  {
    path: '/resultado',
    name: 'Result',
    component: () => import('../views/ResultView.vue')
  },
  {
    path: '/:pathMatch(.*)',
    name: 'Timeline',
    component: () => import('../views/TimelineView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
